import React from "react";
import shopfloLogo from "assests/images/shopflo-secured-logo.svg";
import { useLocale } from "lib/hooks/useLocale";
import useSendAnalyticsEvent from "lib/hooks/useAnalytics";
import { analyticsEvents } from "lib/utils/constants";

interface TermsConditionsProps {
  showSecuredLogo?: boolean;
  variant?: "default" | "compact";
}

const TermsConditions: React.FC<TermsConditionsProps> = ({ showSecuredLogo = true, variant = "default" }) => {
  const { t } = useLocale();
  const { sendAnalyticsEvent } = useSendAnalyticsEvent();

  const wrapperClass =
    variant === "compact" ? "flex flex-col items-center mb-2 mt-0.5" : "flex flex-col items-center gap-3";

  return (
    <div className={wrapperClass}>
      <>
        <p className="pt-1 text-[10px] font-normal text-coal-light leading-4">
          {t("by_continuing_text")}{" "}
          <a
            href="https://shopflo.com/terms-conditions?utm_source=shopflo-checkout&utm_medium=shopflo-checkout&utm_campaign=shopflo-checkout"
            className="font-normal underline"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              sendAnalyticsEvent({
                eventName: analyticsEvents.FLO_TERMS_AND_CONDITIONS,
                eventType: "click",
              });
            }}>
            {t("terms_and_conditions")}
          </a>
          &nbsp;{t("and")}&nbsp;
          <a
            href="https://shopflo.com/privacy-policy?utm_source=shopflo-checkout&utm_medium=shopflo-checkout&utm_campaign=shopflo-checkout"
            className="font-normal underline"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              sendAnalyticsEvent({
                eventName: analyticsEvents.FLO_PRIVACY_POLICY,
                eventType: "click",
              });
            }}>
            {t("privacy_policy")}
          </a>
        </p>
      </>
      {Boolean(showSecuredLogo) && <img src={shopfloLogo} alt={"shopflo-logo"} className="h-3.5" />}
    </div>
  );
};

export default TermsConditions;
